import React from 'react';
import { Plus } from 'theme/icon';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import * as actions_watch from 'redux/actions/watchStockActions';
import * as actions_list from 'redux/actions/watchListActions';
import MiniLoader from 'components/MiniLoader';
import alertify from 'alertifyjs';

const WatchListModal = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
        if (props.user_id) {
            props.loadLists(props.user_id);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
            handleClose();
        }
    };

    const onClickAdd = async (item) => {
        if (!props.symbol || !props.user_id) {
            return;
        }
        const result = await props.newItem({
            id: props.user_id,
            symbol: props.symbol,
            list_id: item.id,
        }, props.token);
        if (result?.success) {
            handleClose();
            alertify.success(I18n.t('watchlist_added'));
            return;
        }
        const errKey = result?.error === 'already_in_list'
            ? 'watchlist_already_in_list'
            : 'watchlist_add_failed';
        alertify.error(I18n.t(errKey));
    };

    return (
        <div className="watchlist-modal-trigger">
            <button
                type="button"
                className="icon-button stock-watchlist-btn"
                onClick={handleClickOpen}
                title={I18n.t('add_watchlist')}
                aria-label={I18n.t('add_watchlist')}
            >
                <Plus />
            </button>

            {open && (
                <div
                    className="dialog watchlist-picker-dialog"
                    role="presentation"
                    onClick={handleBackdropClick}
                >
                    <div
                        className="dialog-content watchlist-picker-content"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="watchlist-picker-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="watchlist-picker-title" className="dialog-title">
                            <Translate value="add_watchlist" />
                        </h2>
                        {props.symbol && (
                            <p className="dialog-content-text">
                                <Translate
                                    value="watchlist_add_symbol"
                                    symbol={props.symbol}
                                />
                            </p>
                        )}

                        <div className="dialog-list-wrap">
                            {props.loading ? (
                                <div className="dialog-list-loading">
                                    <MiniLoader />
                                </div>
                            ) : props.list.length === 0 ? (
                                <p className="dialog-list-empty">
                                    <Translate value="no_watchlists" />
                                </p>
                            ) : (
                                <ul className="dialog-list">
                                    {props.list.map((item) => (
                                        <li key={item.id}>
                                            <button
                                                type="button"
                                                className="dialog-list-item"
                                                onClick={() => onClickAdd(item)}
                                            >
                                                <span className="dialog-list-item-name">{item.name}</span>
                                                <span className="dialog-list-item-icon" aria-hidden="true">
                                                    <Plus />
                                                </span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>

                        <div className="dialog-actions">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                <Translate value="close" />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.watchList.list,
        loading: reducer.watchList.loading,
    };
}

const mapDispatchToProps = (dispatch) => ({
    loadLists: (user_id) =>
        dispatch(actions_list.loadList({ user_id })),
    newItem: (params, token) =>
        dispatch(actions_watch.newItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(WatchListModal);
